export enum ESectionType {
  Index = 'index',
  Rent = 'rent',
  Sale = 'sale',
  NewBuildings = 'new-buildings',
  DailyRent = 'daily-rent',
  Commercial = 'commercial',
  Countryside = 'countryside',
}

export type TSectionType = `${ESectionType}`;
